import React from "react";
import { Navigate } from "react-router-dom";
import { useMyContext } from "@/context/ContextApi";

const ProtectedRoute = ({ children, adminPage }) => {
  // Access the token and isAdmin state by using the useMyContext hook from the ContextProvider
  const { token, isAdmin, currentUser } = useMyContext();

  //navigate to login page to an unauthenticated
  if (!token) {
    return <Navigate to="/login" />;
  }

  if (!currentUser) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-2">
        {/* <Blocks height="70" width="70" color="#4fa94d" /> */}
        <span className="text-muted-foreground">Loading...</span>
      </div>
    );
  }

  //navigate to access-denied page if a user try to access the admin page
  if (token && adminPage && !isAdmin) {
    return <Navigate to="/access-denied" />;
  }

  return children;
};

export default ProtectedRoute;
